
export default function initResources() {
    if (!document.querySelector("#resources-marker")) return;
    bindResources();
}

function bindResources() {
    $('#resourceModal').on('hide.bs.modal', () => updateModal("Resource", null));

    $(".fn-view-resource").click(function () {
        const id = $(this).data("id");
        if (!id) return console.error("No resource id");

        const resource = $(`.fn-resource-data[data-id="${id}"]`);
        const title = resource.data("title");
        const iframe = resource.data("iframe");

        updateModal(title, iframe);
    });
}

function updateModal(title, iframe) {
    console.log("UPDATE");
    $("#resourceModal .modal-title").text(title);
    $("#resourceModal .modal-body").html(iframe);
}